<template>
    <div id="listEnquiry">
        <div id="page-content-wrapper" class="admin-content-area" >
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{title}}</div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content rental-reservation-lists">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <!-- <button type="button" id="getPastReservationList" v-on:click="getPastReservationList(this)" :class="'btn btn-secondary '+ pastActive"> Past <span> {{pastReservationCnt}} </span> </button> -->
                                    <button type="button" id="getCurrentReservationList" v-on:click="getCurrentReservationList(this)" :class="'btn btn-secondary '+ currentActive"> Current <span> {{currentReservationCnt}} </span> </button>
                                    <button type="button" id="getPendingReservationList" v-on:click="getPendingReservationList(this)" :class="'btn btn-secondary '+ pendingActive"> Pending <span> {{pendingReservationCnt}} </span> </button>
                                    <button type="button" id="getAssetAvailabilityList" v-on:click="getAssetAvailabilityList(this)" :class="'btn btn-secondary '+ availabilityActive"> Check Availability <span> {{availableCnt}} </span> </button>
                                </div>
                            </div>

                        </div>
                        <booking id="pendingReservationList" :reservationVal="resVal" v-if="pendingreservationdis === true"></booking>
                        <reservation id="currentReservationList" :reservationVal="curResVal" :filterName="reservationListCurr" v-if="currentreservationdis"></reservation>
                        <reservation id="pastReservationList" :reservationVal="pasResVal" :filterName="reservationListPast" v-if="pastreservationdis"></reservation>
                        <asset-availability id="assetAvailabilityList" :assetAvailabilityVal="avaAssetVal" v-if="assetavailabilitydis == true"></asset-availability>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';

    

    
    import ReservationList from '@/components/Reservation/ReservationList';
    Vue.component("reservation", ReservationList);
    import PendingReservationList from '@/components/Reservation/PendingReservationList';
    Vue.component("booking", PendingReservationList);
    // import AssetAvailability from '@/components/asset/AssetAvailability'
    import SearchAvailableAsset from '@/components/SearchAvailableAsset'
    Vue.component("asset-availability", SearchAvailableAsset);
    var contex

    export default {
        name: "unsyncCustomer",
        mixins: [commonMixins],
        data: () => ({
            reservationListCurr: 'reservationListCurr',
            reservationListPast: 'reservationListPast',
            pastReservationCnt:0,
            pendingReservationCnt:0,
            currentReservationCnt:0,
            totalCnt:0,
            reservedCnt:0,
            availableCnt:0,
            status:[],
            type:'',
            pasResVal:[],
            curResVal:[],
            resVal:[],
            avaAssetVal:[],
            pastreservationdis:false,
            currentreservationdis:false,
            pendingreservationdis:false,
            assetavailabilitydis:false,
            cantAccessPage:"",
            permissions:[],
            loading: false,
            pastActive:"",
            currentActive:"",
            pendingActive:"",
            availabilityActive:"",
            title:'',
            // reservationStatus:[{text:'Past'+contex.pastReservationCnt,value:'rental'},{text:'Lease',value:'lease'}],
            // reservation_type:{text:'Rental',value:'rental'},
        }),


        watch:{

            permissions: function(permission) {
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_unsync_data') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'list_rental_reservation') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            },

            '$route.path':function(val,oldval){
                var self = this;
                var page = self.$route.path.split('/');

                if ( page && page[2] == 'lease'){
                    self.title = 'Lease Reservation List';
                }else{
                    self.title = 'Rental Reservation List';
                }
            },
        },
        metaInfo () {
            var titleStr = "Reservation List | " +process.env.COPYRIGHT_NAME;
            if (this.title.includes('Lease')) {
                titleStr = "Lease " + titleStr;
            }else{
                titleStr = "Rental " + titleStr;
            }
            return{
                title: titleStr
            }
        },
        beforeMount: function() {
            contex = this;
        },

        mounted: function () {

            var self = this;
            EventBus.$emit("profile", false);
            var page = self.$route.path.split('/');

            // console.log(page[2]);
            if (page && page[2] == 'lease'){
                self.title = 'Lease Reservation List';
                self.type = 'lease';
            }else{
                self.title = 'Rental Reservation List';
            }
            // self.pasResVal = [self.type,"getpastreservation"];
            self.curResVal = [self.type,"getcurrentreservation"];
            self.resVal = [self.type,'unsyncbooking'];
            self.avaAssetVal = [self.type,'getavailableasset'];
            console.log([self.type,'getavailableasset']);


            self.getPermissions();
            self.getAssetsCounts();
            setTimeout(function() {

                $("#divTabMenu button").removeClass("active");
            var prevSelectedTab = localStorage.getItem("reservation_list_prev_tab");

                if ( self.$route.query.active == 'current' ) {

                    self.currentActive = "active";
                    self.pastreservationdis = false;
                    self.pendingreservationdis = false;
                    self.currentreservationdis = true;
                    self.assetavailabilitydis = false;

                } else if(self.$route.query.active == 'customer' || self.$route.query.active == "past") {

                    self.pastActive = "active";
                    self.pastreservationdis = true;
                    self.pendingreservationdis = false;
                    self.currentreservationdis = false;
                    self.assetavailabilitydis = false;

                } else if(self.$route.query.active == 'availability') {

                    self.availabilityActive = "active";
                    self.pastreservationdis = false;
                    self.pendingreservationdis = false;
                    self.currentreservationdis = false;
                    self.assetavailabilitydis = true;

                } else {
                    if ( prevSelectedTab == null ) {
                
                        self.selectedStatus = "current";
                        self.currentActive = 'active';
                        self.pastreservationdis = false;
                        self.pendingreservationdis = false;
                        self.currentreservationdis = true;
                        self.assetavailabilitydis = false;
                        localStorage.setItem('reservation_list_prev_tab', 'open_tab');

                    } else {
                
                        if ( prevSelectedTab == 'current' ) {
                            
                            self.selectedStatus = "current";
                            self.currentActive = 'active';
                            self.pastreservationdis = false;
                            self.pendingreservationdis = false;
                            self.currentreservationdis = true;
                            self.assetavailabilitydis = false;

                        } else if ( prevSelectedTab == 'pending' ) {
                            
                            self.selectedStatus = "pending";
                            self.pendingActive = 'active';
                            self.pastreservationdis = false;
                            self.pendingreservationdis = false;
                            self.currentreservationdis = true;
                            self.assetavailabilitydis = false;

                        } else if ( prevSelectedTab == 'past' ) {
                            
                            self.selectedStatus = "past";
                            self.availabilityActive = 'active';
                            self.pastreservationdis = true;
                            self.pendingreservationdis = false;
                            self.currentreservationdis = false;
                            self.assetavailabilitydis = false;

                        }  else if ( prevSelectedTab == 'availability' ) {
                            
                            self.selectedStatus = "availability";
                            self.availabilityActive = 'active';
                            self.pastreservationdis = false;
                            self.pendingreservationdis = false;
                            self.currentreservationdis = false;
                            self.assetavailabilitydis = true;

                        } else {
                            
                            self.selectedStatus = "current";
                            self.currentActive = 'active';
                            self.pastreservationdis = false;
                            self.pendingreservationdis = false;
                                self.currentreservationdis = true;

                            self.assetavailabilitydis = false;
                        }
                    }
                    // // self.pendingActive = "active";
                    // self.currentActive = "active";
                    // self.pastreservationdis = false;
                    // self.pendingreservationdis = false;
                    // self.currentreservationdis = true;
                    // self.assetavailabilitydis = false;
                }
            }, 1000);


        },

        methods: {

            getCurrentReservationList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getCurrentReservationList").addClass("active");
                localStorage.setItem('reservation_list_prev_tab', 'current');
                self.pastreservationdis = false;
                self.$nextTick().then(() => {
                  self.currentreservationdis = true;
                });

                self.pendingreservationdis = false;
                self.assetavailabilitydis = true;
            },

            getPastReservationList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getPastReservationList").addClass("active");

                localStorage.setItem('reservation_list_prev_tab', 'past');
                self.pendingreservationdis = false;
                self.currentreservationdis = false;
                self.$nextTick().then(() => {
                  self.pastreservationdis = true;
                });
                self.assetavailabilitydis = false;
            },

            getPendingReservationList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getPendingReservationList").addClass("active");
                localStorage.setItem('reservation_list_prev_tab', 'pending');
                self.pastreservationdis = false;
                self.pendingreservationdis = true;
                self.currentreservationdis = false;
                self.assetavailabilitydis = true;

            },

            getAssetAvailabilityList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getAssetAvailabilityList").addClass("active");
                localStorage.setItem('reservation_list_prev_tab', 'availability');
                self.pastreservationdis = false;
                self.pendingreservationdis = false;
                self.currentreservationdis = false;
                self.assetavailabilitydis = true;

            },

            getAssetsCounts(){
                //commented code so return
                return;
                // var self = this;
                // self.loading = true;

                // $.ajax({
                //     url: process.env.ROOT_API + "/get-assets-counts",
                //     type: "GET",
                //     headers: this.ajxHeaders,
                //     dataType: "json",
                //     success: function (data) {

                //         self.loading = false;
                //         self.totalCnt = data.content.total;
                //         self.reservedCnt = data.content.reserved;
                //         // self.availableCnt = self.totalCnt - self.reservedCnt;
                //         self.availableCnt = data.content.available;
                //         self.status = data.content.status;

                //     },
                //     error: function (jqXHR, exception) {
                //         //self.loading = false;
                //         $("#saveColumnConfigBtn").val("Save");
                //         $("#saveColumnConfigBtn").prop("disabled", false);
                //         $("#cancelColumnConfigBtn").prop("disabled",false);

                //         self.generateStatusCodeMessage(jqXHR,true,'get-rental-asset-count')
                //     }
                // });
            },

        }
    };

    // TO DO - No need to display counter...
    /*EventBus.$on('unSyncCustomerCnt', function (cnt) {
        contex.customerCnt = cnt;
    });
    EventBus.$on('unSyncPaymentCnt', function (cnt) {
        contex.currentReservationCnt = cnt;
    });*/
    EventBus.$on('pastReservationCount', function (cnt) {
        contex.pastReservationCnt = cnt;
    });

    EventBus.$on('currentReservationCount', function (cnt) {
        contex.currentReservationCnt = cnt;
    });

    EventBus.$on('pendingReservationCount', function (cnt) {
        contex.pendingReservationCnt = cnt;
    });
    
    EventBus.$on('avelableunitCount', function (cnt) {
        contex.availableCnt = cnt;
    });

</script>





// WEBPACK FOOTER //
// src/components/customer/RentalReservationList.vue